/**
 * Utility functions for Microsoft Clarity Custom Identifiers
 * @see https://learn.microsoft.com/en-us/clarity/setup-and-installation/clarity-api
 */

export const clarityIdentifyUser = (userId: string): void => {
  if (typeof window === 'undefined') return;

  try {
    // @ts-expect-error TS(2339): Property 'clarity' does not exist on type 'Window & typeof globalThis'.
    if (window.clarity) {
      // @ts-expect-error TS(2339): Property 'clarity' does not exist on type 'Window & typeof globalThis'.
      window.clarity('identify', userId);
    }
  } catch (error) {
    console.warn('Error identifying user in Clarity:', error);
  }
};

export const clarityClearUserIdentity = (): void => {
  if (typeof window === 'undefined') return;

  try {
    // @ts-expect-error TS(2339): Property 'clarity' does not exist on type 'Window & typeof globalThis'.
    if (window.clarity) {
      // @ts-expect-error TS(2339): Property 'clarity' does not exist on type 'Window & typeof globalThis'.
      window.clarity('identify', '');
    }
  } catch (error) {
    console.warn('Error clearing user identity in Clarity:', error);
  }
};
